import { UserSelector } from '@tencent/tds-ui';
import { RawUserValues } from '@tencent/tds-ui/src/user-selector-pro';
import { Tooltip } from 'antd';
import { isEmpty } from 'lodash-es';
import React, { FC, CSSProperties, useState } from 'react';
import { hintChildren } from '@/presentation/components/hint-text/hintText';
import styles from '@/presentation/components/tapd-info/index.module.scss';
import { useTranslation } from 'react-i18next';

export const RenderUserSelect: FC <{
  name: string | null | undefined,
  label: string | null | undefined,
  getNewFields: (changeValue: string | number, name?: string | null) => void,
  value?: string,
  labelWidth?: string,
  renderSelectWidth?: string,
  style?: CSSProperties,
}> = ({
  name,
  label,
  getNewFields,
  value,
  labelWidth,
  renderSelectWidth,
  style,
}) => {
  const { t } = useTranslation();
  const [isHover, setIsHover] = useState(false);
  const filterValue = value ? [...new Set(value?.split(';'))] : undefined;
  const tips = !isEmpty(filterValue) ? <>{filterValue?.map(item => <div>{item}</div>)}</> : null;

  return (
    <div style={{
      display: 'flex',
      marginBottom: '20px',
      width: renderSelectWidth ?? '300px',
    }}>
    <span className={styles.overflow} style={labelWidth ? { width: labelWidth } : undefined}>
      {hintChildren(label, label)}
    </span>
      <Tooltip title={tips} visible={isHover && !!value}>
        <UserSelector
          placeholder={t("批量输入请用英文;隔开")}
          mode={'tags'}
          showSearch={true}
          suffixIcon={<></>}
          autoFocus={true}
          value={filterValue}
          maxTagCount={'responsive'}
          style={style ?? { width: 200 }}
          optionLabelProp={'value'}
          tokenSeparators={[';', '；']}
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
          onChange={(changeValue: RawUserValues) => {
            const value = changeValue.map(item => item.replace(/\(.*\)/, '')).join(';');
            getNewFields(value, name);
          }}
          wait={100}
        />
      </Tooltip>
    </div>
  );
};
